import {PageSubTitle, PageTitle, ResponsivePageTitle} from '../../components/core/title'
import text from './text.json'
import Input from '../../components/core/input'
import {SimpleBlueButton} from '../../components/core/button'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import {Formik} from 'formik'
import {useState} from 'react'
import {couponSchema} from '../../utils/validation'
import {useDispatch, useSelector} from 'react-redux'
import {getCoupon} from '../../stores/payment'
import {useNavigate} from 'react-router-dom'
import {routes} from '../../routes'
import classNames from 'classnames'

const RedeemCoupon = () => {
    const [showLoader, setShowLoader] = useState(false)
    const navigate = useNavigate()
    const initialFormValues = {
        code: ''
    }
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const dispatch = useDispatch()

    const getCouponInfo = async({code}, {setFieldError}) => {
        setShowLoader(true)
        const success = await dispatch(getCoupon(code?.trim(), setFieldError))
        setShowLoader(false)
        if (success) {
            navigate(routes.plans.path)
        }
    }

    return (
        <main className={classNames('main settings', {
            dark: isDarkMode
        })}>
            <div>
                <ResponsivePageTitle/>
                <div className="content-title">
                    <div className="left-side">
                        <div>
                            <PageSubTitle>
                                <p className={classNames('section', {
                                    dark: isDarkMode
                                })}>{text.section}</p>
                            </PageSubTitle>
                            <PageTitle>
                                <h1  className={classNames('page-title', {
                                    dark: isDarkMode
                                })}>{text.title}</h1>
                            </PageTitle>
                        </div>
                    </div>
                </div>
                <div className="content-body">
                    <Formik
                        initialValues={initialFormValues}
                        onSubmit={getCouponInfo}
                        validationSchema={couponSchema}
                        validateOnBlur={false}
                        validateOnChange={false}>
                        {({values, errors, handleChange, setFieldValue, handleSubmit}) => (
                            <form onSubmit={handleSubmit} className="form-elements">
                                <Input
                                    value={values.code}
                                    placeholder={text.coupon_code}
                                    infoText={text.coupon_code_info}
                                    name="code"
                                    onChange={handleChange}
                                    error={errors.code}
                                />
                                <SimpleBlueButton disabled={showLoader}
                                    type="submit">
                                    {showLoader && <ButtonLoader/>}
                                    {text.submit}
                                </SimpleBlueButton>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
        </main>
    )
}

export default RedeemCoupon
